import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import adduserAgreement from "./components/adduserAgreement";
export default {
  name: "userAgreement",
  mixins: [loadMoreList, serchSelect],
  components: {
    adduserAgreement: adduserAgreement
  },
  data: function data() {
    return {
      pagingReqFn: "userAgreementData",
      pagingReqValue: "",
      drawer: false,
      content: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    consynopsistentView: function consynopsistentView(row) {
      this.content = this.$utils.textRepl(row.content);
      this.drawer = true;
    },
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'userAgreementDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};